export { default, default as InlineLink } from './InlineLink'
export { default as inlineLinkTheme } from './themes/InlineLink.theme'
export * as InlineLinkStyles from './styles/InlineLink.style'

export type { InlineLinkProps } from './InlineLink.types'
export type { AppearanceKeys, InlineLinkTheme } from './themes/InlineLink.theme.types'
export type { StyledInlineLinkProps } from './styles/InlineLink.style.types'
